'use strict';

class ProductEdit {
  constructor($routeParams, $location, $filter, productService, generalLedgerService, userService, originatorService, commonService, Notification) {
    this.$location = $location;
    this.$filter = $filter;
    this.productService = productService;
    this.generalLedgerService = generalLedgerService;
    this.userService = userService;
    this.originatorService = originatorService;
    this.commonService = commonService;
    this.Notification = Notification;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.product = {
      number: null,
      code: null,
      vendorNumber: null,
      description: null,
      unitPrice: 0,
      taxRate: 0,
      accountNumber: null
    };
    this.taxRates = [];
    this.updateRecurring = false;
    this.loadTaxRates();
    this.load();
  }

  load() {
    if (this.number) {
      this.productService.get(this.number)
        .then((resp) => {
          this.product = resp.data;
        })
        .catch(() => this.$location.path('/produkt'));
    } else {
      // Set tax rate
      this.originatorService.get()
        .then((resp) => {
          if (resp.data.organisation.mvaregisteret) {
            this.product.taxRate = 25;
          } else {
            this.product.taxRate = 0;
          }
        });
    }
    // hide "Regnskapskontonummer" if not specified on the account settings
    this.userService.get()
      .then((resp) => {
          this.generalLedgerService.get()
            .then((r) => {
              if (!r.data.salesAccountPerProduct) {
                $('#accountNumber').parent().remove();
              }
            });
      });
  }

  loadTaxRates() {
    this.commonService.getConstants()
      .then((resp) => {
        this.taxRates = resp.taxRates;
      });
  }

  remove() {
    if (this.product.number !== null) {
      swal({
        title: 'Bekreft fjerning fra produktliste',
        showCancelButton: true,
        confirmButtonColor: '#970b0e',
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nei',
        closeOnConfirm: false,
        showLoaderOnConfirm: true
      }, (answer) => {
        if (answer) {
          this.productService.remove(this.product.number)
            .then(() => {
              swal.close();
              this.$location.path('/produkt');
            })
            .catch((err) => {
              this.Notification.error(err.data.endUserMessage);
            });
        }
      });
    }
  }

  save() {
    let clone = angular.copy(this.product);

    // make sure unit price is a number before saving
    clone.unitPrice = this.$filter('numberify')(clone.unitPrice);

    if (this.number) {
      // update existing product
      if (this.updateRecurring) {
        this.productService.updateWithRecurring(clone)
          .then(() => this.$location.path('/produkt'));
      } else {
        this.productService.update(clone)
          .then(() => this.$location.path('/produkt'));
      }
    } else {
      // new product
      this.productService.save(clone)
        .then(() => this.$location.path('/produkt'))
        .catch(() => {
          // reset the form
          this.product = clone;
          this.product.unitPrice = 0;
        });
    }
  }
}

ProductEdit.$inject = ['$routeParams', '$location', '$filter', 'productService', 'generalLedgerService', 'userService', 'originatorService', 'commonService', 'Notification'];

const productEdit = {
  controller: ProductEdit,
  template: `
    <h2>{{ $ctrl.product.code || 'Opprett nytt produkt' }}</h2>

    <form name="productForm" ng-submit="$ctrl.save()" novalidate ng-cloak>
      <div class="row">
        <div class="large-6 columns">
          <fieldset>
            <div>
              <label for="code">Produktnummer</label>
              <input type="text" id="code" name="code" ng-model="$ctrl.product.code" ng-disabled="$ctrl.number" placeholder="max 9 tegn" maxlength="9" required>
            </div>
            <div>
              <label for="description">Produktbeskrivelse</label>
              <input type="text" id="description" name="description" ng-model="$ctrl.product.description" maxlength="50">
            </div>
            <div>
              <label for="vendorNumber">Leverand&oslash;rens produktnummer</label>
              <input type="text" id="vendorNumber" name="vendorNumber" ng-model="$ctrl.product.vendorNumber" maxlength="24">
              <span class="error" ng-show="productForm.vendorNumber.$error.number && productForm.vendorNumber.$dirty">Ugyldig format</span>
            </div>
            <div>
              <label for="accountNumber">Regnskapskontonummer</label>
              <input type="number" id="accountNumber" name="accountNumber" ng-model="$ctrl.product.accountNumber" maxlength="10">
              <span class="error" ng-show="productForm.accountNumber.$error.number && productForm.accountNumber.$dirty">Ugyldig format</span>
            </div>
          </fieldset>
        </div>

        <div class="large-6 columns">
          <fieldset>
            <div>
              <label for="unitPrice">Pris eks. MVA</label>
              <input type="number" id="unitPrice" name="unitPrice" ng-model="$ctrl.product.unitPrice" maxlength="10">
            </div>
            <div>
              <label for="taxRate">MVA</label>
              <select name="taxRate" id="taxRate" ng-model="$ctrl.product.taxRate" ng-options="value as (value + '%') for value in $ctrl.taxRates"></select>
            </div>
          </fieldset>
          <fieldset>
            <div>
              <label for="stockManaged">
                <input type="checkbox" id="stockManaged" name="stockManaged" ng-model="$ctrl.product.stockManaged"> Lagerbeholdning
                <span  data-balloon-length="xlarge" data-balloon="Her kan man skrive inn antall artikler på lager. Når en faktura sendes, vil lagerbeholdningen automatisk justeres ned. Ved forsendelse av kreditnota, vil beholdningen justeres opp igjen."><i class="fa fa-question-circle"></i></span>
              </label>
            </div>
            <div ng-show="$ctrl.product.stockManaged">
              <label for="quantity">Antall</label>
              <input type="number" id="quantity" name="quantity" ng-model="$ctrl.product.quantity" maxlength="10">
            </div>
          </fieldset>
        </div>
      </div>

      <p ng-show="$ctrl.number"><a href="#/rapport/fakturajournal?produkt={{ $ctrl.product.code }}" role="button" class="button secondary"><i class="fa fa-eye"></i> Se regninger</a></p>
      <label ng-show="$ctrl.number">
          <input type="checkbox" ng-model="$ctrl.updateRecurring" value="trye"> Oppdater faste oppdrag
      </label>

      <button type="submit" class="button" ng-disable="productForm.$dirty || productForm.error">Lagre</button>
      <a href="#/produkt" role="button" class="button secondary">Avbryt</a>
      <a href class="button secondary" ng-show="$ctrl.number" role="button" ng-click="$ctrl.remove()">Slett</a>
    </form>
  `
};

angular
  .module('SendRegning')
  .component('productEdit', productEdit)
  .config(($routeProvider) => {
    $routeProvider
      .when('/produkt/nytt', {
        title: 'Vedlikehold av produkt',
        template: '<product-edit />',
        secure: true
      })
      .when('/produkt/:number', {
        title: 'Vedlikehold av produkt',
        template: '<product-edit />',
        secure: true
      });
  });
